/**
 * How the app DISPLAYS a date - one rule for calendar dates and timestamps.
 *
 * ⛔⛔ B-DT1 (the 101st): a Postgres `date` column arrives as `2021-10-05`, and `new Date('2021-10-05')` is
 *    MIDNIGHT UTC - the evening of Oct 4 in California - so `toLocaleDateString` showed the day BEFORE, and a
 *    month-only label showed the month before for anything dated the 1st. A calendar date names a DAY, not a
 *    moment, so it is formatted in UTC, where that midnight lives; a timestamp is a moment and is still shown
 *    in local time, exactly as before.
 */
const CALENDAR_DATE = /^\d{4}-\d{2}-\d{2}$/;

export const displayDate = (
  value: string | null | undefined,
  options?: Intl.DateTimeFormatOptions,
): string | null => {
  if (!value) return null;
  const d = new Date(value);
  if (Number.isNaN(d.getTime())) return null;
  return CALENDAR_DATE.test(value)
    ? d.toLocaleDateString('en-US', { ...options, timeZone: 'UTC' })
    : d.toLocaleDateString('en-US', options);
};
